import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import { CookieService } from 'ngx-cookie-service';

import * as _ from 'lodash';

@Component({
  selector: 'app-search-menu-product',
  templateUrl: './search-menu-product.component.html',
  styleUrls: ['./search-menu-product.component.scss']
})
export class SearchMenuProductComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() info: {
    IsLoding: boolean
    ORG_Company_ID: string,
    ORG_Store_ID: string,
    PRDProductNo: string,
  };

  //---------"與父組件共用，不可改位址------->---------------------
  @Input() ProductList: Array<any>;  //商品清單

  //-----------------------談窗----------------------------

  modalRef = null;  //談窗鉤子
  PdModalRef = null;  //談窗鉤子

  @ViewChild('Modal') Modal: TemplateRef<any>
  @ViewChild('PdModal') PdModal: TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  selectData: Array<any>;//已選資料
  mainDataList: Array<any>; //顯示資料  
  originalDataList: FlattenedMenu[] = [];
  showList: Array<any>;     //群組顯示資料 
  showListPd: Array<any>;   //商品顯示資料 
  query = {  //查詢選項
    searchKey: "",
    ORG_Company_ID: null,
    ORG_Store_ID: null,
  }
  status = { //當前狀態
    isSelectAll: false, //是否已全選
    AllSelectCount: 0, //當前已選總數量
    showType: null // 顯示有選過的
  }


  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  PRD_PlatformType_ID: number;
  selectPRDMenuNo: string = '';
  titleList: TitleOption[] = [];

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,

  ) {
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.query.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
  }

  //info 資料來源 = callAPI / 外部丟入
  //data 來源 =  MainData[ListName]

  //全選功能:
  // 撈取全部資料以提供全選 -  那麼分頁將不再重要 : 建議改成設定欄位
  // 全選讀取設定，非全選讀取陣列 
  // 同上問題，在經過搜尋之後的全選將有所刪減，因此除了"全選設定欄位"，還要加上查詢欄位，在後端進行查詢
  // 同上問題，過程中的其他方的新增，可能導致有額外資料產生。
  // 但不管是丟設定到後端查後取資，一開始取全資但顯示還是每頁只抓當頁資料，都可能造成以上問題。
  // 因此最佳處理還是一開始就丟出全部到前端顯示。 但如此行為可能導致效能緩慢? 
  // 單頁全選-可以正常運作

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)
  }


 //開啟
  onOpen(info, useData) {
    

    if (info){
      this.info = info
    }
      

    this.mainDataList = []
    this.selectData = []

    //存下已選資料
    if(useData && useData.length){
      this.selectData =  _.cloneDeep(useData) 
    }

    //api抓資料
    this.getProductList((data) => {
      this.showData(data)  
    })  
    

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  // 組資料
  showData(data) {
    //組合內容

    let ProductList: FlattenedMenu[] = [];
    
    data.LIST.forEach(menu => {
      if(menu.pDMenuGroupDTOs != null){
        menu.pDMenuGroupDTOs.forEach(group => {
          const IsOK_Group = group.pdMenuPdDetailDTOs.every(product => product.isSelect === "1");

          const convertedPDList = group.pdMenuPdDetailDTOs.map(product => ({
            ...product,
            PRDMenuProductGroupNo: group.PRDMenuProductGroupNo,
            IsOK_Product: product.isSelect === "1"
          }));

          const menuItem = new MenuImplementation();
          Object.assign(menuItem, {
              PRDMenuNo: menu.PRDMenuNo,
              ORG_Company_ID: menu.ORG_Company_ID,
              ORG_Store_ID: menu.ORG_Store_ID,
              StoreName: menu.StoreName,
              Version: menu.Version,
              ORGStoreIDs: menu.ORGStoreIDs,
              PRD_PlatformType_ID: menu.PRD_PlatformType_ID,
              Title: menu.Title,
              PRDMenuProductGroupNo: group.PRDMenuProductGroupNo,
              GroupName: group.GroupName,
              PDList: convertedPDList,
              IsOK_Group: IsOK_Group
          });
          
          ProductList.push(menuItem);
      });
      }
        
    });

    // 保存原始資料
    this.originalDataList = ProductList;
    // 初始顯示所有資料
    this.mainDataList = [...this.originalDataList];

    this.mainDataList.forEach(g => {
        g.IsOK_Product_Count();
    });
    
    this.sumSelect();

    const uniqueCombos = [...new Set(this.mainDataList.map(item => `${item.PRDMenuNo}|${item.Title}`))];
    this.titleList = uniqueCombos.map(combo => {
        const [PRDMenuNo, Title] = combo.split('|');
        return {
            value: PRDMenuNo,
            label: Title
        };
    });
    setTimeout(() => {
      if (this.titleList.length > 0) {
          this.selectPRDMenuNo = this.titleList[0].value;
      }
      this.onQuery();
    });
  
  }


  //查詢
  onQuery() {
    if (this.selectPRDMenuNo) {
        this.mainDataList = this.originalDataList.filter(item => 
            item.PRDMenuNo === this.selectPRDMenuNo
        );
    } else {
        this.mainDataList = [...this.originalDataList];
    }
    
    this.sumSelect();
  }


  //加入已選商品
  AddSelectData(pd,isSelect){
    if(isSelect){
      if(!_.find(this.selectData,a=>a.PRDProductNo==pd.PRDProductNo)){
        this.selectData.push(pd)
      }
    }else{
      _.remove(this.selectData,x=>x.PRDProductNo==pd.PRDProductNo)
    }
  }


  //選擇全部資料
  onSelectAllG() {
    this.mainDataList.forEach(group => {
      group.IsOK_Group = this.status.isSelectAll
      _.forEach(group.PDList, p => {
        p.IsOK_Group = group.IsOK_Group
        p.IsOK_Product = group.IsOK_Group
        this.AddSelectData(p,group.IsOK_Group)
      });
      group.IsOK_Product_Count()
     
    })
    this.sumSelect()
  }


  //統計已選數量
  sumSelect() {
    let selectCount = 0
    let allcount = 0
    this.mainDataList.forEach(group => {
      selectCount += group.CountSum
      allcount += group.PDList.length
    })

    this.status.AllSelectCount = selectCount
    this.status.isSelectAll = (selectCount == allcount)

  }


  //商品群組 選擇
  onSelectG(GID) {
    let group = _.find(this.mainDataList, a => a.PRDMenuProductGroupNo == GID)
    if (group)
      _.forEach(group.PDList, p => {
        p.IsOK_Group = group.IsOK_Group
        p.IsOK_Product = group.IsOK_Group
        this.AddSelectData(p,group.IsOK_Group)
      });
    console.log(group)
    group.IsOK_Product_Count()

    this.sumSelect()
  }


  //處存商品群組  最終存檔!!
  onSavePdG() {
    this.emitList.emit(this.selectData)
    this.modalRef.close()
  }


  //商品 打開彈窗
  onOpenPd(GID) {
    let group = _.find(this.mainDataList, a => a.PRDMenuProductGroupNo == GID)
    this.showListPd = _.cloneDeep(group.PDList)

    //開啟談窗
    this.PdModalRef = this.dialogService.open(this.PdModal, {})
  }


  //商品 處存
  onSavePd() {
    let GID = this.showListPd[0].PRDMenuProductGroupNo
    let group = _.find(this.mainDataList, a => a.PRDMenuProductGroupNo == GID)
    console.error(GID);
    console.error(this.mainDataList);
    console.error(group);
    console.error(this.showListPd);
    _.assign(group.PDList, this.showListPd)
    group.IsOK_Group = _.findIndex(group.PDList, 'IsOK_Product') > -1
    group.IsOK_Product_Count()

    if(group.PDList){
      group.PDList.forEach(x=>{
        this.AddSelectData(x,x.IsOK_Product)
      })
    }

    this.sumSelect()

    this.PdModalRef.close()
  }


  //取得可用商品資料
  getProductList(fun) {
    this.info.IsLoding = true
    this.http.post<any>('api/Menu/QueryPRDMenuWithProductNo', {
      PRDProductNo: this.info.PRDProductNo,
      ORG_Company_ID: this.info.ORG_Company_ID,
      ORG_Store_ID: this.info.ORG_Store_ID,
    }).subscribe({
      next: data => {
        this.info.IsLoding = false

        if (fun)
          fun(data)

      },
      error: error => {
        console.error('There was an error!', error);
        this.info.IsLoding = false
      }
    });
  }
}


class selectData {
  value: number;//
  content: string;//
  info: string
}

interface MenuDetail {
  PRDProductNo: string;
  ProductName: string;
  IsOK_Product?: boolean; 
}

interface MenuGroup {
  PRDMenuProductGroupNo: string;
  GroupName: string;
  Sorting: number;
  pdMenuPdDetailDTOs: MenuDetail[];
}

interface Menu {
  PRDMenuNo: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  StoreName: string;
  Version: null;
  ORGStoreIDs: null;
  PRD_PlatformType_ID: number;
  Title: string;
  pDMenuGroupDTOs: MenuGroup[];
}

interface FlattenedMenu {
  PRDMenuNo: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  StoreName: string;
  Version: null;
  ORGStoreIDs: null;
  PRD_PlatformType_ID: number;
  Title: string;
  PRDMenuProductGroupNo: string;
  GroupName: string;
  PDList: MenuDetail[];
  IsOK_Group: boolean;
  CountStr?: string;  // 新增屬性
  CountSum?: number;  // 新增屬性
  IsOK_Product_Count(): void;  // 方法定義
}

class MenuImplementation implements FlattenedMenu {
  PRDMenuNo: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  StoreName: string;
  Version: null;
  ORGStoreIDs: null;
  PRD_PlatformType_ID: number;
  Title: string;
  PRDMenuProductGroupNo: string;
  GroupName: string;
  PDList: MenuDetail[];
  IsOK_Group: boolean;
  CountStr: string = '';
  CountSum: number = 0;

  IsOK_Product_Count(): void {
      const use = this.PDList.filter(item => item.IsOK_Product).length;
      this.CountStr = use === this.PDList.length ? '已全選' : `已選${use}項`;
      this.CountSum = use;
  }
}

interface TitleOption {
  value: string;  // PRDMenuNo
  label: string;  // Title
}